<template>
  <div>
    <v-btn
      v-if="!!subTotal"
      @click.prevent.stop="showDrawer"
    >
      Pay
    </v-btn>
    <v-btn
      v-else
      readonly
      disabled
    >
      Paid
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'UserPayButton',
  components: {},
  props: { subTotal: { type: Number }, userId: { type: Number } },
  methods: {
    showDrawer() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.PAY_DRAWER_SHOW, {
        subTotal: this.subTotal,
        userId: this.userId
      });
    }
  }
};
</script>
